import type { ReactElement, ComponentProps, Ref, RefObject } from 'react';

import { RovingIndexProvider } from '../../contexts';
import { useMergedRef } from '../../hooks';

type ProviderProps = Omit<
  ComponentProps<typeof RovingIndexProvider>,
  'parentRef' | 'children'
>;

type Props<T extends HTMLElement> = {
  ref?: Ref<T>;
  children: (props: { ref: RefObject<T | null> }) => ReactElement;
} & ProviderProps;

export function RovingIndexContainer<T extends HTMLElement>({
  children,
  ref,
  ...props
}: Props<T>) {
  const mergedRef = useMergedRef(ref);

  return (
    <RovingIndexProvider parentRef={mergedRef} {...props}>
      {children({ ref: mergedRef })}
    </RovingIndexProvider>
  );
}
